import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  // Uncomment to check changeDetection time for performance monitoring
  // and run `ng.profiler.timeChangeDetection()` in the console terminal
  // .then((module) => enableDebugTools(module.injector.get(ApplicationRef).components[0]))
  .catch((err) => console.error(err));
